import { render, staticRenderFns } from "./flag.vue?vue&type=template&id=3ff327f8&scoped=true&"
import script from "./flag.vue?vue&type=script&lang=js&"
export * from "./flag.vue?vue&type=script&lang=js&"
import style0 from "./flag.vue?vue&type=style&index=0&id=3ff327f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff327f8",
  null
  
)

export default component.exports